const types = {
    SET_SHIFT: '[CASHIER] SET SHIFT',
}

export {
    types
}